import { Media } from 'ca-api-client';
import { mediaFilters } from '@/filters/media';
export default class UploadNewVersion {
    config() {
        return {
            title: 'Upload new version',
            description: 'Upload a new media item to replace the current one.',
            initialView: 'MediaUpload',
            mode: 'single',
            media: true,
            sets: false,
            upload: {
                allow: true,
                newVersion: true,
                allowMultiple: false,
                onProcessFile: this.processFile,
            },
            defaultFilters: [
                { type: 'image,video,document,before_after,audio,other' },
                { interactive_id: null },
                { 360: null },
                { public: null },
            ],
            filterOptions: mediaFilters,
        };
    }
    processFile(file) {
        const item = App.$store.getters.getMediaViewCurrentItem;
        item.status = 'processing';
        item.thumbnailPending = true;

        return new Promise((resolve, reject) => {
            const serverJson = JSON.parse(file.serverId).data;
            serverJson.url = file.getFileEncodeDataURL();
            const serverData = new Media(serverJson);

            App.$store.dispatch('prependGalleryMediaSelectItem', serverData).then(() => {
                App.$store.dispatch('hideMediaSelectModal').then(() => {
                    ca.notify({
                        icon: 'edit',
                        type: 'success',
                        message: `${serverData.title} was replaced with a new version.`,
                        timeout: ca.config('toast.timeout'),
                    });
                });
                resolve(serverData);
            });
        }).catch((error) => {
            console.log(error);
        });
    }
    doAction() {
        console.log('UploadNewVersion::doAction()');
        const options = App.$store.getters.getMediaSelectOptions;
        const item = App.$store.getters.getMediaSelectCurrentSelection;

        return App.$store.dispatch('updateGalleryItem', {
            id: options.itemId,
            data: {
                file_id: item.file_id,
            },
        });
    }
}
